import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';

//Componentes
import Loading from '../../../components/Loading/Loading';
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';

//Helpers
import { PrintValidate, objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';

//API
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';
import destino_api from '../../../api/destino_api';
import relatorio_api from '../../../api/relatorio_api';

//Context
import { useAuth } from '../../../context/auth';
import RelatorioRedestinacoesDestino from './RelatorioRedestinacoesDestino';

function initialStateFiltros() {
    const dataAtual = new Date();
    dataAtual.setMonth(dataAtual.getMonth() - 1);
    const dataInicial = moment(dataAtual).format("YYYY-MM-DD");
    dataAtual.setMonth(dataAtual.getMonth() + 1);
    const dataFinal = moment(dataAtual).format("YYYY-MM-DD");

    return {
        dataInicial,
        dataFinal,
        modalidadeId: 0,
        modalidadeId_selected: null,
        destinoId: 0,
        destinoId_selected: null,
        nomeRelatorio: "Relatórios - Redestinações"
    }
}

function RedestinacoesDestino() {
    const { session } = useAuth();

    //Estado que valida os possiveis erros nos campos de filtros
    const [errors, setErrors] = useState({});

    //Guarda os filtros obrigatorios
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true })
    ];

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState();

    //Estado que guarda os valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Opções de modalidades de coleta
    const [optionsModalidades, setOptionsModalidades] = useState([]);

    //Opções de destinos de coleta
    const [optionsDestinos, setOptionsDestinos] = useState([]);

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState(null);

    //Variavel de navegação na tela
    const navigate = useNavigate();

    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Change para os campos modalidade e transportadores
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0
        });
    }

    const loadModalidades = () => {
        setLoading(true)
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            });
            setOptionsModalidades(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    const loadDestinos = () => {
        destino_api.GetList()
            .then(response => {
                response.data = response.data.map(value => {
                    return { value: value.id, label: value.fantasia };
                });
                setOptionsDestinos(response.data);
            }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {

        const _errors = validarCampos(filtros, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        if (new Date(filtros.dataInicial).getTime() > new Date(filtros.dataFinal).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } })
            return;
        } else {
            setErrors({});
        }

       if(session.acesso?.sigla == "DS")
       {
        setFiltros({
            ...filtros,
            destinoId_selected: {label: session?.acesso?.acesso_descricao},
            destinoId:  session?.acesso?.acesso_id
        })
       }

        setLoading(true);
        relatorio_api.RedestinacaoDestinos(filtros)
            .then(response => {

                setDadosRelatorio(response.data);
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadModalidades();
        loadDestinos();
    }, []);

    if (dadosRelatorio != null) {
        return <RelatorioRedestinacoesDestino
            dadosRelatorio={dadosRelatorio}
            btnVoltar={() => setDadosRelatorio(null)}
            filtros={filtros} />
    }

    return (<MainCard btnVoltarInTop={() => navigate(-1)}>
        {loading && <Loading />}
        <h4>Relatório Redestinações</h4>
        <Row>
            <Col sm="12" md="6" lg={session?.acesso?.modulo == "Gestor" ? "2" : "4"}>
                <TextField
                    name="dataInicial"
                    label={"* Data inicial"}
                    type={"date"}
                    value={filtros.dataInicial}
                    onChange={onChangeFiltros}
                    invalid={!!errors.dataInicial}
                />
                <PrintValidate field={"dataInicial"} errors={errors} />
            </Col>
            <Col sm="12" md="6" lg={session?.acesso?.modulo == "Gestor" ? "2" : "4"}>
                <TextField
                    name="dataFinal"
                    label={"* Data final"}
                    type={"date"}
                    value={filtros.dataFinal}
                    onChange={onChangeFiltros}
                    invalid={!!errors.dataFinal}
                />
                <PrintValidate field={"dataFinal"} errors={errors} />
            </Col>
            <Col sm="12" md="6" lg={session?.acesso?.modulo == "Gestor" ? "4" : "4"}>
                <TextField
                    placeholder='Selecione'
                    name="modalidadeId_selected"
                    label={"Modalidade"}
                    type={"select"}
                    searchable
                    value={filtros.modalidadeId_selected}
                    invalid={!!errors.modalidadeId_selected}
                    onChange={onChangeSelected}
                    options={optionsModalidades}
                />
            </Col>
            {session?.acesso?.modulo == "Gestor" &&
                <Col sm="12" md="6" lg={"4"}>
                    <TextField
                        placeholder='Selecione'
                        name="destinoId_selected"
                        label={"Destino"}
                        type={"select"}
                        searchable
                        value={filtros.destinoId_selected}
                        invalid={!!errors.destinoId_selected}
                        onChange={onChangeSelected}
                        options={optionsDestinos}
                    />
                </Col>
            }
            <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                <Button
                    className='w-100 fw-bold'
                    color='info text-light'
                    onClick={carregarRelatorio}>Gerar Relatório</Button>
            </Col>
        </Row>
    </MainCard>)
}

export default RedestinacoesDestino;